import React from "react";
import Dupecheckdetailsview from "../../../jsx/components/Dashboard/DupeCheckDetailsView/dupecheckdetailsview";

const DupeCheckDetailsView = () => {
  return <Dupecheckdetailsview />;
};

export default DupeCheckDetailsView;
